import { ENTORNO } from "../utils/constantes";
import { getToken } from "../utils/variablesLocales";

//consola de administracion
//https://www.google.com/recaptcha/admin/site/698566298/settings

export class apigoogleRecaptchaV3 {
  baseApi = ENTORNO.BASE_API;

  async verificar(tokenGoogleRecaptchaV3, ipPublicaValor) {
    try {
      const url = `${this.baseApi}/${ENTORNO.API_ROUTES.GoogleRecaptchaV3_verificargoogleRecaptchaV3}`;

      const parametros = {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify({
          tokenGoogleRecaptchaV3: tokenGoogleRecaptchaV3,
          ipPublicaValor: ipPublicaValor,
        }),
      };

      const respuesta = await fetch(url, parametros);
      const respuestaJson = await respuesta.json();

      return respuestaJson.success;
    } catch (error) {
      throw error;
    }
  }
}
